exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-element-data{margin-left:-24px;width:calc(100% + 48px)!important;height:32px}.input-element-data .v-input__control{padding:0!important;min-height:10px!important}.input-element-data .v-input__control .v-input__slot{margin-bottom:0!important;min-height:0}.input-element-data .v-input__control .v-text-field__slot input{margin-top:0}.input-element-data .v-text-field.v-text-field--solo .v-input__prepend-outer{margin-top:4px!important}.input-element-data .v-text-field.v-text-field--full-width{position:relative}.input-element-data .v-text-field.v-text-field--full-width.date-type .v-input__prepend-outer{position:absolute}.input-element-data .v-text-field.v-text-field--full-width.date-type .v-input__control{margin-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-510d6f8d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/edition/components/VBaseInput.vue
// module id = 2154
// module chunks = 0